import { render, staticRenderFns } from "./CircularLoadingSpinner.vue?vue&type=template&id=0b5b1d70&scoped=true&"
import script from "./CircularLoadingSpinner.vue?vue&type=script&lang=js&"
export * from "./CircularLoadingSpinner.vue?vue&type=script&lang=js&"
import style0 from "./CircularLoadingSpinner.vue?vue&type=style&index=0&id=0b5b1d70&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5b1d70",
  null
  
)

export default component.exports